import { renderTerms, type IsoDate, type SoldTerms } from '@lemontaigu/pms-core';

// The terms a logement was SOLD under (PB7b, PMS-PHONE-BOOKING-BRIEF §4.4): its
// plan's policy, copied when the room was created, with this stay's dates and
// amounts. So a Booking.com room reads its 50 % on cancellation and an Expedia
// room its prepayment due at check-in — whatever the policy says today.
//
// « Montant total » = the room nights, board and extras, never the taxe de
// séjour: the caller passes the preview's total without it.

export function SoldTermsNote({
  terms,
  saved,
  arrival,
  totalCents,
}: {
  terms: SoldTerms | null | undefined;
  /** The logement exists in the database (has an id). */
  saved: boolean;
  arrival: IsoDate;
  totalCents: number;
}) {
  if (!saved) {
    return <p className="pms-sub">Conditions d’annulation : celles du plan, copiées à l’enregistrement.</p>;
  }
  if (terms == null) {
    return <p className="pms-sub">Conditions d’annulation : non enregistrées (vendu avant les conditions par plan).</p>;
  }
  const text = renderTerms(terms, 'fr', { arrival, totalCents });
  return (
    <div className="pms-sold-terms">
      <strong>
        Conditions d’annulation{terms.labelFr ? ` — ${terms.labelFr}` : ''}
        {/* PB4: the desk's numbers for this guest, not the policy's. */}
        {terms.relaxed === true ? ' (assouplies pour ce client)' : ''}
      </strong>
      <ul>
        <li>{text.prepayment}</li>
        {text.cancellation.map((line) => (
          <li key={line}>{line}</li>
        ))}
        <li>{text.noShow}</li>
      </ul>
    </div>
  );
}
